import { Moment } from 'moment';
import { OperationContext } from '../../../common/operations/enums/OperationContext';
import { OperationType } from '../../../common/operations/enums/OperationType';

export class Operation {
  constructor(
    private readonly id: number,
    private readonly type: OperationType,
    private readonly context: OperationContext,
    private readonly algorithms: string[],
    private readonly timestamp: Moment | null
  ) {}

  getId() {
    return this.id;
  }

  getType() {
    return this.type;
  }

  getContext() {
    return this.context;
  }

  getAlgorithms() {
    return this.algorithms;
  }

  getTimestamp() {
    return this.timestamp;
  }
}
